<template>
  <div class="c-comment-item">
    <div class="c-avatar c-default-img">
      <img v-if="item.photo" :src="item.photo" alt />
    </div>
    <div class="c-comment-content">
      <div class="c-top-info">
        <div class="flex-l">
          <div class="c-username">{{item.name}}</div>
          <gxxt-tag color="#f50" text-color="#fff" size="small">置顶</gxxt-tag>
        </div>
        <gxxt-zan
          :value="item.like"
          :number="item.likeNum"
          show-number
          @click="handleLike(item.like, item.id)"
        ></gxxt-zan>
      </div>
      <div class="c-time">{{dates.formatDate(new Date(item.commentTime))}}</div>
      <div class="c-score">
        <span class="c-label">综合评分</span>
        <gxxt-rate v-model="item.starNum" show-score></gxxt-rate>
      </div>
      <div class="c-content">{{item.comment}}</div>
    </div>
  </div>
</template>

<script>
import { GxxtRate, GxxtTag, GxxtZan } from '@/components'
import dates from '@/utils/dates'
import { getCurrentInstance } from 'vue'
import {
  setLikeGoodsComment,
  setUnlikeGoodsComment,
} from '@/api/modules/course'
export default {
  components: {
    GxxtRate,
    GxxtTag,
    GxxtZan,
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
    index: {
      type: [Number, String],
      default: 0,
    },
  },
  setup(props, ctx) {
    const currentInstance = getCurrentInstance()
    const global = currentInstance.appContext.config.globalProperties

    const handleLike = async (like, id) => {
      let res,message
      if (!like) {
        res = await setLikeGoodsComment(id)
        message = '点赞成功'
      } else {
        res = await setUnlikeGoodsComment(id)
        message = '取消点赞成功'
      }
      if (res && res.code == 200) {
        global.$toaster({
          message,
        })
        ctx.emit('changeItemLike', props.index)
      }
    }
    return { handleLike }
  },
  data() {
    return {
      dates,
    }
  },
}
</script>

<style scoped lang="less">
.c-comment-item {
  display: flex;
  padding: 50px 12px 0;
  .c-comment-content {
    flex: 1 0 0;
  }
  .c-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 20px;
    img {
      width: 80px;
      height: 80px;
    }
  }
  .c-top-info {
    display: flex;
    justify-content: space-between;

    .c-username {
      font-size: 30px;
      font-weight: 500;
      color: #333333;
      line-height: 30px;
      padding-right: 20px;
    }
  }
  .c-label,
  .c-time {
    font-size: 22px;
    color: #aaaaaa;
    line-height: 50px;
  }
  .c-score {
    display: flex;
    .c-label {
      padding-right: 20px;
    }
  }
  .c-content {
    font-size: 30px;
    color: #333333;
    line-height: 50px;
  }
}
</style>